import { NAVIGATION_ROUTES } from '@/routes/constants';
import TokenService from '@/services/service.token';
import React, { ComponentType, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
type WithAuthProps = {};

function withAuth<T extends WithAuthProps>(
  WrappedComponent: ComponentType<T>,
): React.FC<Omit<T, keyof WithAuthProps>> {
  return function AuthenticatedComponent(props: Omit<T, keyof WithAuthProps>) {
    const navigate = useNavigate();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, setIsLoading] = useState(true);
    useEffect(() => {
      const token = TokenService.getToken();
      if (!token) {
        navigate(NAVIGATION_ROUTES.SIGNIN);
      } else {
        setIsLoading(false);
      }
    }, [navigate]);

    return <WrappedComponent {...(props as T)} />;
  };
}

export default withAuth;
